import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NoContentBox } from 'components/basic'
import { notify } from 'helpers'
import http from 'API/http'
import FileSaver from 'file-saver'

class ServiceExport extends Component {
  async componentDidMount () {
    var err, res
    [err, res] = await http.get('2.3/services/csv/')
    if (err) notify.alert('', 'Export failed, try again', 'error')
    if (!err) {
      var blob = new window.Blob([res.data], { type: 'text/csv' })
      FileSaver.saveAs(blob, 'ServiceExport.csv')
    }
    window.location.hash = '/access'
  }
  render () {
    return (
      <div className='content-wrapper flexbox-absolute-center'>
        <NoContentBox icon='circle-o-notch fa-spin' text='Starting Download' />
      </div>
    )
  }
}
//eslint-disable-next-line
ServiceExport = connect(state => state.siteReducer)(ServiceExport)
export default ServiceExport



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/2.3/core/services.js